import * as React from "react";
import { Context } from "./_context";
export const MovingExpenseIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M22.629 3.508a1.001 1.001 0 0 1 .815 1.32l-.05.12L21.5 8.735V19.5a1 1 0 0 1-1 1h-17a1 1 0 0 1-1-1V8.736L.606 4.947l1.789-.894L4.118 7.5h4.764l1.724-3.447.07-.121A1 1 0 0 1 11.5 3.5h11l.129.008ZM4.5 18.5h4v-9h-4v9Zm6 0h9v-9h-9v9Zm.618-11h8.764l1-2h-8.764l-1 2Z", fill: "currentColor" }));
  return iconset[size];
};
MovingExpenseIcon.iconId = "4jFgfV";
